import styled from "styled-components"

import {CommonProps, commonCSS} from "../common"

import {mainStyles} from "./styles"

export interface InputProps extends CommonProps {
  id?: string
  color?: string
}

export default styled.span<InputProps>`
  ${mainStyles}
  ${commonCSS}
`
